import {
  Box,
  Grid,
  Link,
  Paper,
  Button,
  Divider,
  useTheme,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Heading from "../Heading";
import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import GlobalSubHeading from "../GlobalSubHeading";
import { getMeaning } from "../../utils/localization";
import { FooterStyles } from "../../layout/HomeLayout/Styles";
import { FastestGrowingStyles, GetInTouchStyles } from "../Styles"; // Assuming it has modular styles
import { Facebook, Instagram, LinkedIn, Twitter } from "@mui/icons-material";

const GetInTouch = () => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("sm"));

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "your_service_id", // Replace with your EmailJS service ID
        "your_template_id", // Replace with your EmailJS template ID
        form.current,
        "your_public_key" // Replace with your EmailJS public key
      )
      .then(
        (result) => {
          console.log("Email sent:", result.text);
          alert("Message sent successfully!");
          form.current.reset();
        },
        (error) => {
          console.error("Email error:", error.text);
          alert("Failed to send message. Please try again.");
        }
      );
  };

  return (
    <Box
      // sx={{
      //   ...GetInTouchStyles.container,
      //   py: 4,
      //   px: 2,
      // }}
      sx={FastestGrowingStyles.root}
    >
      <Grid
        container
        spacing={4}
        alignItems="flex-start"
        justifyContent="center"
      >
        <Grid item xs={12} sm={6} md={6}>
          <Box sx={GetInTouchStyles.textSection}>
            <Heading title={getMeaning("HME.INQRYHDNG")} />

            <Box align="center">
              <GlobalSubHeading subTitle={getMeaning("HME.INQRYSBHDNG")} />
            </Box>
          </Box>

          <Divider
            sx={{
              my: 3,
              width: "90%",
              borderColor: "#ccc",
              borderBottomWidth: 2,
            }}
          />

          <Box sx={{ mt: 3 }}>
            <Typography
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: { md: "center" },
                ...GetInTouchStyles.LabelTxt,
              }}
            >
              📧 {getMeaning("FOTR.EMLUS1")}
              <Typography
                component="span"
                sx={{
                  ml: { md: 1 }, // add margin only for md and above
                  ...GetInTouchStyles.LabelValueTxt,
                }}
              >
                {getMeaning("FOTR.EMLUS2")}
              </Typography>
            </Typography>

            <Typography
              sx={[
                GetInTouchStyles.LabelTxt,
                {
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: { md: "center" },
                },
              ]}
            >
              🏢 {getMeaning("FOTR.REACHUSAT1")}
              <Box>
                <Typography
                  sx={[
                    GetInTouchStyles.LabelValueTxt,
                    { marginTop: { xs: 0, md: 6 } },
                  ]}
                >
                  {getMeaning("FOTR.REACHUS1")}
                </Typography>
                <Typography sx={[GetInTouchStyles.LabelValueTxt]}>
                  {getMeaning("FOTR.REACHUS2")}
                </Typography>
                <Typography sx={[GetInTouchStyles.LabelValueTxt]}>
                  {getMeaning("FOTR.REACHUS3")}
                </Typography>
              </Box>
            </Typography>

            {/* <Typography sx={GetInTouchStyles.LabelTxt}>
              📞 {getMeaning("FOTR.CALLUS1")}
              <Typography sx={GetInTouchStyles.LabelValueTxt}>
                {getMeaning("FOTR.CALLUS3")}
              </Typography>
            </Typography> */}
            <Typography
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: { md: "center" },
                ...GetInTouchStyles.LabelTxt,
              }}
            >
              📞 {getMeaning("FOTR.CALLUS1")}
              <Typography
                component="span"
                sx={{
                  ml: { md: 1 }, // add margin only for md and above
                  ...GetInTouchStyles.LabelValueTxt,
                }}
              >
                {getMeaning("FOTR.CALLUS3")}
              </Typography>
            </Typography>

            <Typography sx={GetInTouchStyles.LabelTxt}>
              🌐 {getMeaning("FOTR.FOLLOWUS1")}
              <Box>
                <Link
                  href="https://facebook.com"
                  target="_blank"
                  sx={FooterStyles.socialIconsTwo}
                >
                  <Facebook />
                </Link>
                <Link
                  href="https://twitter.com"
                  target="_blank"
                  sx={FooterStyles.socialIconsTwo}
                >
                  <Twitter />
                </Link>
                <Link
                  href="https://linkedin.com"
                  target="_blank"
                  sx={FooterStyles.socialIconsTwo}
                >
                  <LinkedIn />
                </Link>
                <Link
                  href="https://instagram.com"
                  target="_blank"
                  sx={FooterStyles.socialIconsTwo}
                >
                  <Instagram />
                </Link>
              </Box>
            </Typography>
          </Box>
        </Grid>

        {/* Right Form Section */}
        <Grid item xs={12} md={6}>
          <Paper
            elevation={3}
            sx={{
              ...GetInTouchStyles.formCard,
              p: { xs: 2, sm: 3, md: 4 },
            }}
            style={{
              boxShadow: 6,
              borderRadius: 6,
              backgroundColor: "#fff",
              // border: "0.6px solid #353E43",
              border: "2px solid #cfd8dc",
            }}
          >
            <Heading title={getMeaning("HME.GTNTCHHDNG")} />

            <Typography
              sx={[GetInTouchStyles.formSubtext, { textAlign: "justify" }]}
            >
              {getMeaning("HME.GTNTCHSBHDNG")}
            </Typography>

            <Grid
              container
              spacing={2}
              sx={{ mt: 1 }}
              style={{ width: "100%" }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    sx={{
                      width: { xs: "272px", md: "240px" },
                      fontFamily: '"Poppins", serif',
                      fontSize: "0.9rem",
                    }}
                    variant="outlined"
                    label={getMeaning("HME.FSTNMELBL")}
                    InputProps={{
                      sx: {
                        fontFamily: '"Poppins", serif',
                        fontSize: "0.9rem",
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontFamily: '"Poppins", serif',
                        fontSize: "0.9rem",
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    sx={{
                      width: { xs: "272px", md: "240px" },
                      fontFamily: '"Poppins", serif',
                      fontSize: "0.9rem",
                    }}
                    variant="outlined"
                    label={getMeaning("HME.LSTNMELBL")}
                    InputProps={{
                      sx: {
                        fontFamily: '"Poppins", serif',
                        fontSize: "0.9rem",
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontFamily: '"Poppins", serif',
                        fontSize: "0.9rem",
                      },
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    sx={{
                      width: { xs: "272px", md: "240px" },
                      fontFamily: '"Poppins", serif',
                      fontSize: "0.9rem",
                    }}
                    variant="outlined"
                    label={getMeaning("HME.EMLADRSLBL")}
                    InputProps={{
                      sx: {
                        fontFamily: '"Poppins", serif',
                        fontSize: "0.9rem",
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontFamily: '"Poppins", serif',
                        fontSize: "0.9rem",
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    sx={{
                      width: { xs: "272px", md: "240px" },
                      fontFamily: '"Poppins", serif',
                      fontSize: "0.9rem",
                    }}
                    variant="outlined"
                    label={getMeaning("HME.CMPNYNMELBL")}
                    InputProps={{
                      sx: {
                        fontFamily: '"Poppins", serif',
                        fontSize: "0.9rem",
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontFamily: '"Poppins", serif',
                        fontSize: "0.9rem",
                      },
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    sx={{
                      width: { xs: "272px", md: "240px" },
                      fontFamily: '"Poppins", serif',
                      fontSize: "0.9rem",
                    }}
                    variant="outlined"
                    label={getMeaning("HME.INDSTRYLBL")}
                    InputProps={{
                      sx: {
                        fontFamily: '"Poppins", serif',
                        fontSize: "0.9rem",
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontFamily: '"Poppins", serif',
                        fontSize: "0.9rem",
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    sx={{
                      width: { xs: "272px", md: "240px" },
                      fontFamily: '"Poppins", serif',
                      fontSize: "0.9rem",
                    }}
                    variant="outlined"
                    label={getMeaning("HME.PHNELBL")}
                    InputProps={{
                      sx: {
                        fontFamily: '"Poppins", serif',
                        fontSize: "0.9rem",
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontFamily: '"Poppins", serif',
                        fontSize: "0.9rem",
                      },
                    }}
                  />
                </Grid>
              </Grid>

              <Grid item xs={12} sm={6} style={{ width: "100%" }}>
                <TextField
                  fullWidth
                  multiline
                  variant="outlined"
                  label={getMeaning("HME.YRMSGLBL")}
                  sx={{
                    fontFamily: '"Poppins", serif',
                    fontSize: "0.9rem",
                    minHeight: 150,
                    "& .MuiInputBase-root": {
                      alignItems: "center",
                      height: "100%",
                      minHeight: 150,
                      fontSize: "0.9rem",
                    },
                    "& .MuiInputBase-inputMultiline": {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      paddingTop: "auto",
                      paddingBottom: "auto",
                      fontFamily: '"Poppins", serif',
                      fontSize: "0.9rem",
                    },
                  }}
                  InputLabelProps={{
                    sx: { fontFamily: '"Poppins", serif', fontSize: "0.9rem" },
                  }}
                />
              </Grid>
            </Grid>

            <Typography sx={GetInTouchStyles.privacyText}>
              {getMeaning("HME.PRVCYPLCY")}
              <Box component="span" sx={GetInTouchStyles.privacyLink}>
                {getMeaning("HME.PRVCYPLCY2")}
              </Box>
              {getMeaning("HME.PRVCYPLCYDSCP")}
            </Typography>

            <Button
              variant="contained"
              fullWidth={isSm}
              sx={GetInTouchStyles.submitButton}
              // onClick={sendEmail}
            >
              {getMeaning("HME.SNDMSGBTN")}
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default GetInTouch;
